import { useEffect, useState } from 'react';

/**
 * Whether this tab is the one the user is looking at.
 *
 * A read receipt is shown to the person who sent the message, so "read" has
 * to mean someone was actually in front of the screen. A background tab left
 * open on a conversation is not that.
 */
export function useDocumentVisible(): boolean {
  const [visible, setVisible] = useState(() => document.visibilityState === 'visible');

  useEffect(() => {
    const onChange = () => setVisible(document.visibilityState === 'visible');
    document.addEventListener('visibilitychange', onChange);
    return () => document.removeEventListener('visibilitychange', onChange);
  }, []);

  return visible;
}
